import type { Core, Data } from '@strapi/types';
import { useMutation } from '@tanstack/react-query';
import { useApi } from '@/modules/utils/custom-hooks/use-api';
import { createCustomerApi, updateCustomerApi, deleteCustomerApi } from '../api/customer.api';

export const useCustomerApi = () => {
	const { onSuccess } = useApi({ queryKey: ['GET_CUSTOMER_LIST'], closeModal: false });

	const createCustomer = useMutation({
		mutationKey: ['[POST]:CREATE_CUSTOMER'],
		mutationFn: (body: Core.Helpers.Controllers.GetRequestBody<'api::customer.customer', 'create'>) => createCustomerApi({ body }),
		onSuccess: () => {
			onSuccess('T_SUCCESS_CUSTOMER_CREATED');
		},
	});

	const updateCustomer = useMutation({
		mutationKey: ['[PUT]:UPDATE_CUSTOMER'],
		mutationFn: ({
			documentId,
			body,
		}: {
			documentId: Pick<Data.Entity<'api::customer.customer'>, 'documentId'>['documentId'];
			body: Core.Helpers.Controllers.GetRequestBody<'api::customer.customer', 'update'>;
		}) => updateCustomerApi({ documentId, body }),
		onSuccess: () => onSuccess(),
	});

	const deleteCustomer = useMutation({
		mutationKey: ['[DELETE]:DELETE_CUSTOMER'],
		mutationFn: ({ documentId }: { documentId: Pick<Data.Entity<'api::customer.customer'>, 'documentId'>['documentId'] }) =>
			deleteCustomerApi({ documentId }),
		onSuccess: () => onSuccess('T_SUCCESS_CUSTOMER_DELETED'),
	});

	const isPending = createCustomer.isPending || updateCustomer.isPending || deleteCustomer.isPending;
	const error = createCustomer.error || updateCustomer.error || deleteCustomer.error;

	return {
		createCustomer,
		updateCustomer,
		deleteCustomer,
		isPending,
		error,
	};
};
